<template>
  <transition name="quick-fade">
    <section id="video" class="o-section o-modal c-video" v-if="videoOpen" @click="closeVideo">
      <header class="o-modal__tools">
        <span class="o-modal__close">
          <button @click="closeVideo">
            <svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg>
          </button>
        </span>
      </header>
      <div class="o-modal__content c-video__content" @click.prevent>
        <div class="c-video__container">
          <div class="o-aspect" v-if="videoSrc">
            <div class="o-aspect__inner">
              <iframe :src="videoSrc" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: 'my-video',
  computed: {
    videoOpen () {
      return this.$store.state.videoOpen
    },
    videoSrc () {
      return this.$store.state.videoSrc
    }
  },
  methods: {
    closeVideo () {
      this.$store.commit('setVideo', false)
    }
  },
  watch: {
    videoOpen (val) {
      if (val === true) {
        document.body.classList.add('u-body-lock-scroll')
      } else {
        document.body.classList.remove('u-body-lock-scroll')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyVideo.vue?202c6a70